import styled from '@emotion/styled';
import { BottomArea, TitleArea, ViewArea } from '@ps-smart-cp/ppfw-client';
import type { ReactNode } from 'react';

const MainAreaForErrorPage = styled.div`
  margin-left: 12px;
  margin-right: 12px;
  overflow: visible;
  background-color: #ffffff;
  border: 1px solid #777777;
  border-radius: 2px;
  box-shadow: 2px 2px 2px #888888;
`;

interface ErrorTemplateProps {
  children?: ReactNode;
  title: string;
}

export function ErrorViewTmpl(props: ErrorTemplateProps) {
  const { title, children } = props;

  return (
    <MainAreaForErrorPage>
      <TitleArea title={title} />
      <ViewArea>{children}</ViewArea>
      <BottomArea />
    </MainAreaForErrorPage>
  );
}
